// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3aiN2","errors":"Errors_errors__1UfqK"};